import { useScrollToTop } from "../../Utility";
import { Suspense, lazy } from "react";
import { RenderLoadingSpinnerInImageTag } from "../LoggedInComponents/Helper";

// * import method different because its a lazy load import
const AboutHero = lazy(() => import("./AboutHero"));
const AboutDetails = lazy(() => import("./AboutDetails"));

export default function About() {
  // * At the top of the page.
  useScrollToTop();

  // * Return Component with lazy setup
  function returnComponentWithLazySetup(Component, loadingMsg) {
    return (
      <Suspense
        fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
      >
        {Component}
      </Suspense>
    );
  }

  return (
    <>
      {returnComponentWithLazySetup(<AboutHero />, "Loading about page..")}

      {returnComponentWithLazySetup(
        <AboutDetails />,
        "Loading about page details .."
      )}
    </>
  );
}
